import BaseService from 'common/services/baseService';
import {
  GET_USER,
  RECOMMENDATION_URL,
  USER_DASHBOARD_COURSES_URL,
} from 'community/dashboard/utils/constants';

export class DashboardService extends BaseService {
  /**
   * Get user courses
   * @param query
   */
  async getCourses({ query }: IGetDashboardCoursesParams) {
    const params: any = {};
    if (query && query.length) {
      params.query = `{${query.join(',')}}`;
    }
    return await this.get(USER_DASHBOARD_COURSES_URL, params);
  }

  /**
   * Get recommendations.
   */
  async getRecommendations() {
    return await this.get(RECOMMENDATION_URL);
  }

  /**
   * Get logged in user
   */
  async getUser() {
    return await this.get(GET_USER, { my: 1 });
  }

  /**
   * Accept AI Planet teams invitation
   * */
  async acceptTeamsInvitation(invitationId: string) {
    return await this.post(
      '/api/dphi-business/learner/invite/accept/',
      {},
      { params: { invitationId } }
    );
  }

  async teams() {
    return await this.get('/api/dphi-business/learner/dashboard/');
  }
}
